import { PasswordSanitizer } from "../Utils/PasswordSanitizer";
import { Device } from "./Device";


export class UrlBuilder
{
    public static WatcherPage(device: Device)
    {
        return (process.env.WATCHER_WATCH_PAGE || "")
            .replace("{server}", device.ServerId)
            .replace("{password}", PasswordSanitizer.Sanitize(device.Password.value));
    }
}
